<template>
    <div>
        <div class="block with-errors" >
            <div class="title">
                <IconLocation height="20" classes="settings-icon vertical-center" />
                <div>{{ $t('city') }}</div>
                <div class="change" @click="edit" v-if="! editing">{{ $t('change') }}</div>
            </div>
            <div class="value" v-if="! editing" @click="edit">{{ user.place.name }}</div>
            <div class="bottom">
                <div class="input-item text-right" :class="{ error : hasError('city') }" v-if="editing">
                    <input type="test" id="edit-city" 
                        v-model="value" 
                        @keyup="complete"
                        @focusout="unedit">
                    <div class="autocomplete" :class="completion?'':'invisible'">
                        <div class="list" v-if="cities.length">
                            <div class="item" v-for="(city, index) in cities" :key="city.name" @click="select(index)">
                                {{ city.name }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="error-text" v-if="hasError('city')">
                    {{ $t('errors.' + getError('city')) }}
                </div>
                <SaveButton :editing="editing" @save="save" />
            </div>
        </div>
    </div>
</template>

<script>
import SaveButton from '@/components/visual/SaveButton'
import IconLocation from '@/components/visual/icons/IconLocation'
import { mapState, mapGetters } from 'vuex'

export default {
    components: { SaveButton, IconLocation },
    data() {
        return {
            editing: false,
            stopEditing: false,
            completion: false,
            value: '',
        }
    },
    created() {
        this.value = this.user.place.name
    },
    methods: {
        complete(event) {
            this.completion = true
            this.$store.dispatch('city/complete', event.target.value)
        },
        select(index) {
            this.$store.dispatch('city/select', index)
                .then(() => {
                    this.editing = true
                    this.stopEditing = false
                    this.completion = false
                    this.value = this.city.manual.name
                    document.getElementById('edit-city').focus()
                })
        },
        edit() {
            this.editing = true
            this.stopEditing = false
            this.completion = true
            this.$store.dispatch('city/complete', this.value)
            setTimeout(() => { document.getElementById('edit-city').focus() }, 10)
        },
        unedit() {
            this.stopEditing = true
            setTimeout(() => { 
                if (this.stopEditing) {
                    this.editing = false 
                    this.completion = false
                }
            }, 500)
        },
        save() {
            this.$store.dispatch('errors/clear')
            this.$store.dispatch('auth/saveCity', { 
                city: this.city.manual.name, 
                placeid: this.city.manual.placeid 
            })
                .then(() => {
                    if (this.hasError('city') || this.hasError('placeid')) 
                        this.edit()
                    else {
                        this.unedit()
                        this.$store.dispatch('message/show' , this.$t('citySaved'))
                        this.$store.dispatch('predictions/reloadData')
                    }
                })
        },
    },
    computed: {
        ...mapGetters('errors', {
            hasError: 'has',
            getError: 'getFirst',
        }),
        ...mapState('auth', {
            user: state => state.user
        }),
        ...mapState('city', ['city', 'cities'])
    }
}
</script>

<i18n locale="ru" lang="yaml">
  city: "Мой город"
  citySaved: "Новый город сохранен."
  change: "Изменить"
  errors:
    city:
        required: "Обязательно выберите город"
</i18n>

<i18n locale="en" lang="yaml">
  city: "My city"
  citySaved: "New city saved."
  change: "Change"
  errors:
    city:
        required: "City required"
</i18n>
